import { hasCookieConsent } from './abTests';

export type AbTesting = {
  isEnabled?: boolean;
  apiHost?: string;
  group?: 'control' | 'variant';
};

export const cofeNextAbTestLocalStorageHost = 'cofeNextApiHost';

const setCofeNextAbTest = (injectedCofeNextAbTest: AbTesting) => {
  if (!injectedCofeNextAbTest.isEnabled || !hasCookieConsent()) {
    localStorage.removeItem(cofeNextAbTestLocalStorageHost);
    return;
  }

  if (!localStorage.getItem(cofeNextAbTestLocalStorageHost)) {
    localStorage.setItem(cofeNextAbTestLocalStorageHost, injectedCofeNextAbTest.apiHost!);
  }
};

export default setCofeNextAbTest;
